import { SfFilterRelationalOperators, SfFilterTypes } from "./sf_constants";

export const dynamicSort = (property) => {
  let sortOrder = 1;
  if (property[0] === '-') {
    sortOrder = -1;
    property = property.substr(1);
  }
  return function (a, b) {
    /* next line works with strings and numbers,
         * and you may want to customize it to your needs
         */
    const result = (a[property] < b[property]) ? -1 : (a[property] > b[property]) ? 1 : 0;
    return result * sortOrder;
  };
};

export const getStateSelectValuesFromAdgroup = (state, adGroupSfFilters) => {
  let adgroup = state.adGroup
  let selectedModTypes = []
  let selectedIds = []
  let selectedIncludes = []
  let selectedGroup = []
  let selectedMultiValues = []
  let filter_conditions = adgroup && adgroup.ad_group_filter_groups && adgroup.ad_group_filter_groups[0]?.ad_group_filters;
  let form_rows = []
  let tracking_info = {
    dest_url: '',
    fallback_url: '',
    click_integration_id: '',
    has_click_integration: false,
    transfer_number: '',
    is_sip: false,
  };
  let minMaxValues = []
  let arrayValues = []
  if (filter_conditions) {
    const filters = adgroup.ad_group_filter_groups[0]?.ad_group_filters?.filter(
      (ad_group_filter) => adGroupSfFilters.some((fltr) => fltr?.id === ad_group_filter?.sf_filter_id)
    )
    for (let i = 0; i < filters.length; ++i) {
      form_rows.push({ id: i })
      selectedGroup.push({
        label: getSfFilterNameForAdgroupById(adGroupSfFilters, filters[i].sf_filter_id),
        value: filters[i].sf_filter_id, filter_type: getSfFilterTypeForAdgroupById(adGroupSfFilters, filters[i].sf_filter_id),
        price: getSfFilterPriceForAdgroupById(adGroupSfFilters, filters[i].sf_filter_id)
      })
      selectedIncludes.push(filters[i].include)
      let values = []
      const eval_param = eval(filters[i].filter_value)
      for (let j = 0; j < eval_param.length; ++j) {
        values.push({
          label: eval_param[j],
          value: eval_param[j]
        })
      }
      selectedMultiValues.push(values)
      arrayValues.push(filters[i].filter_value_array)
      //Push ids
      if (filters[i].id !== undefined) {
        selectedIds.push(filters[i].id)
      }
      else {
        selectedIds.push(null)
      }

      if (getSfFilterTypeForAdgroupById(adGroupSfFilters, filters[i].sf_filter_id) === SfFilterTypes.MIN_MAX) {
        minMaxValues.push({ filter_value_min: filters[i].filter_value_min, filter_value_max: filters[i].filter_value_max })
      } else {
        minMaxValues.push(null);
      }

      //Push ModType
      if (filters[i].id !== undefined) {
        selectedModTypes.push("update")
      }
      else {
        selectedModTypes.push("new")
      }

    }
  }

  // //NOW GETTING THESE OPTIONS FROM SERVER
  // else{
  //     //Look for default state
  //     if ((adgroup?.default_state !== undefined) && (adgroup.default_state != null))
  //     {
  //         let state = adgroup?.default_state.split("(")[1].split(")")[0]
  //         let full_state_name = adgroup?.default_state.split("(")[0]
  //         form_rows.push({id:0})
  //         selectedGroup.push({label: 'State',value: getSfFilterIdForAdgroupByName(ad_group_sf_filters,'State')})
  //         selectedIncludes.push(true)
  //         let value_row = [{label: state, value: full_state_name}]
  //         selectedMultiValues.push(value_row)
  //         selectedIds.push(null)
  //         selectedModTypes.push("new")

  //     }
  // }
  tracking_info.dest_url = adgroup?.click_ad_group_setting?.dest_url;
  tracking_info.fallback_url = adgroup?.click_ad_group_setting?.fallback_url;
  tracking_info.click_integration_id = adgroup?.click_ad_group_setting?.click_integration_id;
  tracking_info.has_click_integration = (adgroup?.click_ad_group_setting?.has_click_integration === undefined) ? false : adgroup?.click_ad_group_setting?.has_click_integration;
  tracking_info.transfer_number = adgroup?.call_ad_group_setting?.transfer_number;
  tracking_info.is_sip = adgroup?.call_ad_group_setting?.is_sip;

  return [selectedModTypes, selectedIds, selectedIncludes, selectedGroup, selectedMultiValues, form_rows, tracking_info, minMaxValues, arrayValues]
};

export const getFilterConditionsFromAdgroup = (adgroup, adGroupSfFilters) => {
  const [selectedModTypes, selectedIds, selectedIncludes, selectedGroup, selectedMulti, form_rows] = getStateSelectValuesFromAdgroup(adgroup, adGroupSfFilters);
  const filter_conditions = [];
  for (let i = 0; i < selectedGroup.length; ++i) {
    const obj = {
      sf_filter_id: (selectedGroup[i].value),
      filter_value: selectedMulti[i].map((arr) => arr.value),
      include: selectedIncludes[i],
      id: selectedIds[i],
      modification_type: selectedModTypes[i],
    };
    filter_conditions.push(obj);
  }
  return filter_conditions;
};

export const isTrackingEnabledAtCampaignLevel = (campaigns, id) => {
  const activeCampaign = campaigns.filter((el) => el.id == id)[0];

  return activeCampaign?.is_campaign_level_tracking === true;
};

export const getSfFilterIdForAdgroupByName = (adGroupSfFilters, key_name) => {
  if (adGroupSfFilters === undefined || adGroupSfFilters.length < 1) {
    return '';
  }
  const sf_filter_id = adGroupSfFilters?.filter((el) => el.name === key_name)[0]?.id;
  return sf_filter_id;
};

export const getSfFilterNameForAdgroupById = (adGroupSfFilters, id) => {
  if (adGroupSfFilters === undefined || adGroupSfFilters.length < 1) {
    return '';
  }
  const sf_filter_name = adGroupSfFilters?.filter((el) => el.id === id)[0]?.name;
  return sf_filter_name;
};
export const getSfFilterPriceForAdgroupById = (adGroupSfFilters, id) => {
  if (adGroupSfFilters === undefined || adGroupSfFilters.length < 1) {
    return '';
  }
  const sf_filter_price = adGroupSfFilters?.filter((el) => el.id === id)[0]?.price;
  return sf_filter_price;
};
export const getSfFilterTypeForAdgroupById = (adGroupSfFilters, id) => {
  if (adGroupSfFilters === undefined || adGroupSfFilters.length < 1) {
    return ''
  }
  let sf_filter_isSingle = adGroupSfFilters?.filter((el) => el.id === id)[0]?.filter_type;
  return sf_filter_isSingle
}

export const isAdGroupTrackingInfoComplete = (click_ad_group_setting) => {
  if (click_ad_group_setting?.has_click_integration === true) {
    return (click_ad_group_setting?.click_integration_id === null) ? false : true;
  }
  else {
    return ((click_ad_group_setting?.dest_url === null) || (click_ad_group_setting?.dest_url === '')) ? false : true;
  }
}

export const genericValidationForTargetingSection = (filterModType, selectedInclude, selectedGroup = [], selectedMulti, selectedMinMaxArray, selectedArray = []) => {

  let isInvalidTargeting = false;

  if (selectedInclude.length !== selectedGroup.length && selectedInclude.length !== selectedMulti.length && selectedInclude.length !== selectedArray.length) {
    isInvalidTargeting = true;
  } else {
    selectedGroup.map((single_arr, index) => {
      if (!selectedMulti[index]?.length && !selectedArray[index]?.length && filterModType[index] !== 'delete') {
        isInvalidTargeting = true;
      }
      if (filterModType[index] !== 'delete') {
        if (!single_arr.value) {
          isInvalidTargeting = true;
        }
        if (single_arr.filter_type === SfFilterTypes.MIN_MAX) {
          if (selectedMulti[index][0]?.value === SfFilterRelationalOperators.EQUAL_TO) {
            if ((!selectedMinMaxArray[index]?.filter_value_min) && (!selectedMinMaxArray[index]?.filter_value_max)) {
              isInvalidTargeting = true;
            }
          }
          if (selectedMulti[index][0]?.value === SfFilterRelationalOperators.LESS_THAN) {
            if (!selectedMinMaxArray[index]?.filter_value_max) {
              isInvalidTargeting = true;
            }
          }
          if (selectedMulti[index][0]?.value === SfFilterRelationalOperators.MORE_THAN) {
            if (!selectedMinMaxArray[index]?.filter_value_min) {
              isInvalidTargeting = true;
            }
          }
          if (selectedMulti[index][0]?.value === SfFilterRelationalOperators.BETWEEN) {
            if (!selectedMinMaxArray[index]?.filter_value_min) {
              isInvalidTargeting = true;
            } if (!selectedMinMaxArray[index]?.filter_value_max) {
              isInvalidTargeting = true;
            }
          }
        }
      }
    })

  }

  return isInvalidTargeting;
}

/**
 * 
 * @param {arr} adgroups 
 * @param {bool} is_campaign_level_tracking 
 * @returns bool
 */
export const getMissingTrackingMessage = (adgroups, is_campaign_level_tracking) => {
  if (adgroups && is_campaign_level_tracking) {
    return false;
  }
  const isActiveAdgroups = adgroups?.filter(single => (single.active === true) && (!!single?.click_ad_group_setting?.dest_url == false)) || null;

  if (isActiveAdgroups?.length) {
    return true;
  }
  return false;
}

export const getProfit = (ad_group, pixelColValuesForAdGroup, total_payout_metric_name = 'click_analytic_total_payout') => {


  const cost = parseFloat(ad_group?.[total_payout_metric_name])
  const total_revenue = pixelColValuesForAdGroup.reduce((partialSum, a) => partialSum + parseFloat(a.revenue), 0)


  return isNaN(total_revenue - cost) ? 0 : (total_revenue - cost);
}

export const getMargin = (ad_group, pixelColValuesForAdGroup, total_payout_metric_name = 'click_analytic_total_payout') => {

  const cost = parseFloat(ad_group?.[total_payout_metric_name])
  const total_revenue = pixelColValuesForAdGroup.reduce((partialSum, a) => partialSum + parseFloat(a.revenue), 0)
  return isNaN(100 * (total_revenue - cost) / total_revenue) ? 0 : (100 * (total_revenue - cost) / total_revenue).toFixed(2);
}